<div>
  <div class="container">
    <div class="row">
      <div class="col" style="margin: 15px 0;">
        <h2>Система внутреннего контроля качества</h2>
        <p>Политика и конкретные процедуры внутреннего контроля качества работы, позволяющие
          обеспечить разумную уверенность в том, что ООО «Эвномия Аудит» и ее сотрудники соблюдают
          профессиональные стандарты и применимые правовые и нормативные требования, а также в том,
          что заключения и иные отчеты, выпущенные Обществом или руководителями заданий, носят
          надлежащий характер в конкретных обстоятельствах, закреплены во внутреннем положении
          «Правила осуществления внутреннего контроля качества работы (ПВККР)».</p>
        <p>ПВККР устанавливает единые требования к системе контроля качества услуг в Обществе и
          распространяется на все задания, относящиеся к аудиторской деятельности. Установленные
          политика и конкретные процедуры внутреннего контроля качества являются обязательными к
          исполнению всем сотрудниками Общества.
        </p>
        <p>
          Исполнительный орган заявляет, что в ООО «Эвномия Аудит» создана и эффективно
          функционирует система внутреннего контроля качества работы, соответствующая масштабам
          деятельности Общества и требованиям законодательства об аудиторской деятельности в
          Российской Федерации, МСКК № 1 «Контроль качества в аудиторских организациях, проводящих
          аудит и обзорные проверки финансовой отчетности, а также выполняющих прочие задания,
          обеспечивающие уверенность, и задания по оказанию сопутствующих услуг», МСА № 220
          «Контроль качества при проведении аудита финансовой отчетности» и других применимых
          нормативных правовых актов.</p>
        <p>В целях обеспечения условий для самообразования приобретается специализированная
          литература, информационные базы. Сотрудники, имеющие квалификационные аттестаты
          аудиторов, ежегодно проходят повышение квалификации (продолжительность курса не менее 40
          часов в год) в порядке, установленном действующим законодательством, за счет средств ООО
          «Эвномия Аудит».</p>
        <h3>Внешняя проверка качества работы аудиторской организации</h3>
        <p>В 2024 году ООО «Эвномия Аудит» успешно прошло плановую проверку внешнего контроля качества работы аудиторской организации со стороны Ассоциации «Содружество» (протокол № 30-24 от 25.12.2024 г.).</p>
        <p>По результатам проверки два аудитора получили свидетельства, подтверждающие отсутствие нарушений в рамках осуществления внешнего контроля деятельности аудиторской организации.</p>
        <p>В настоящий момент отсутствуют какие-либо применяемые в отношении ООО «Эвномия Аудит» меры дисциплинарного и иного воздействия.</p>


      </div>
    </div>
  </div>

</div>
